import React from 'react';
import { Link } from 'react-router-dom';

/**
 * A2P SMS opt-in checkboxes — copy is governed by docs/A2P_SMS_COMPLIANCE.md §1.
 * Consent is optional and unchecked by default; both values are submitted as
 * explicit true/false by the parent form.
 */
export default function SmsConsentFieldset({ consent, onChange, disabled }) {
  return (
    <fieldset className="cx-consent">
      <legend className="cx-label">SMS Consent (Optional)</legend>
      <label className="cx-consent__option">
        <input
          type="checkbox"
          checked={consent.marketing}
          disabled={disabled}
          onChange={(e) => onChange({ ...consent, marketing: e.target.checked })}
        />
        <span>
          I consent to receive marketing text messages from Build Construx, Inc, including
          promotional offers, new product announcements, free estimate announcements, and company
          updates at the phone number provided. Message frequency may vary. Message &amp; data
          rates may apply. Text HELP for assistance, reply STOP to opt out.
        </span>
      </label>
      <label className="cx-consent__option">
        <input
          type="checkbox"
          checked={consent.nonMarketing}
          disabled={disabled}
          onChange={(e) => onChange({ ...consent, nonMarketing: e.target.checked })}
        />
        <span>
          I consent to receive non-marketing text messages from Build Construx, Inc regarding
          appointment confirmations and reminders, project scheduling updates, installation status
          updates, estimate follow-ups, invoice notifications, and customer support responses.
          Message frequency may vary. Message &amp; data rates may apply. Text HELP for
          assistance, reply STOP to opt out.
        </span>
      </label>
      <p className="cx-consent__links">
        Consent is not a condition of purchase. See our <Link to="/privacy">Privacy Policy</Link>{' '}
        and <Link to="/terms">Terms of Service</Link>.
      </p>
    </fieldset>
  );
}

export function smsConsentSubmissionFields(consent) {
  return {
    sms_marketing_consent: consent.marketing ? 'true' : 'false',
    sms_transactional_consent: consent.nonMarketing ? 'true' : 'false',
  };
}
